<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="号源医院" :required="true" hasFeedback>
              <!-- 1 石景山八大处中西医结合医院
1368745172330483714 北京中研集团东城中医医院
1452810551314948098 北京中研中医院
1452811085769940994 北京天使望京妇儿医院 -->
                  <a-select v-decorator="['registerHospitalId']">
                    <a-select-option  value="1">石景山八大处中西医结合医院</a-select-option>
                    <a-select-option value="1368745172330483714">北京中研集团东城中医医院</a-select-option>
                    <a-select-option value="1452810551314948098">北京中研中医院</a-select-option>
                    <a-select-option value="1452811085769940994">北京天使望京妇儿医院</a-select-option>
                  </a-select>
                </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择日期" v-decorator="['date', validatorRules.date]" :trigger-change="true"
                      style="width: 100%"/>
            </a-form-item>
          </a-col>
           <a-col :span="24">
                      <!-- <a-form-item label="时间段123" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input v-decorator="['vartPart']" placeholder="请输入时间段" style="width: 100%"/>
                      </a-form-item> -->
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="时间段" :required="true" hasFeedback >
              <a-select v-decorator="['vartPart']">
                <a-select-option value="全天">全天</a-select-option>
                <a-select-option value="上午">上午</a-select-option>
                <a-select-option value="下午">下午</a-select-option>
                <a-select-option value="晚上">晚上</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="开始时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-time-picker placeholder="开始时间" v-decorator="['startTime']" :trigger-change="true" :show-time="true" value-format="HH:mm:ss" style="width:100%"/>

              <!-- <j-date placeholder="请选择开始时间" v-decorator="['startTime']" :trigger-change="true" :show-time="true"
                      date-format="HH:mm" style="width: 100%"/> -->
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="结束时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-time-picker placeholder="请选择结束时间" v-decorator="['endTime']" :trigger-change="true" :show-time="true" value-format="HH:mm:ss" style="width:100%"/>
              <!-- <j-date placeholder="请选择结束时间" v-decorator="['endTime']" :trigger-change="true" :show-time="true"
                      date-format="HH:mm" style="width: 100%"/> -->
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="总号量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['total']" placeholder="请输入总号量" style="width: 100%"/>
            </a-form-item>
          </a-col>
         
          <a-col :span="24">
            <a-form-item label="医生姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="false">
              <a-input v-decorator="['doctorNanme']" placeholder="请输入医生姓名"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="医生id" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="false">
              <a-input v-decorator="['doctorId']" placeholder="请输入医生姓名"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

import {httpAction, getAction} from '@/api/manage'
import pick from 'lodash.pick'
import {validateDuplicateValue} from '@/utils/util'
import JFormContainer from '@/components/jeecg/JFormContainer'
import JDate from '@/components/jeecg/JDate'

export default {
  name: 'MakeAppointmentForm',
  components: {
    JFormContainer,
    JDate,
  },
  props: {
    //流程表单data
    formData: {
      type: Object,
      default: () => {
      },
      required: false
    },
    //表单模式：true流程表单 false普通表单
    formBpm: {
      type: Boolean,
      default: false,
      required: false
    },
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      model: {},
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
      confirmLoading: false,
      validatorRules: {
        date: {
          rules: [
            {required: true, message: '请输入日期!'},
          ]
        },
      },
      url: {
        add: "/makeAppointment/makeAppointment/add?doctorId="+this.$route.params.id,
        edit: "/makeAppointment/makeAppointment/edit",
        queryById: "/makeAppointment/makeAppointment/queryById"
      }
    }
  },
  computed: {
    formDisabled() {
      if (this.formBpm === true) {
        if (this.formData.disabled === false) {
          return false
        }
        return true
      }
      return this.disabled
    },
    showFlowSubmitButton() {
      if (this.formBpm === true) {
        if (this.formData.disabled === false) {
          return true
        }
      }
      return false
    }
  },
  created() {
    //如果是流程中表单，则需要加载流程表单data
    this.showFlowData();
  },
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'date', 'startTime', 'endTime', 'total', 'surplus', 'doctorId', 'doctorNanme', 'invaild'))
      })
    },
    //渲染流程表单数据
    showFlowData() {
      if (this.formBpm === true) {
        let params = {id: this.formData.dataId};
        getAction(this.url.queryById, params).then((res) => {
          if (res.success) {
            this.edit(res.result);
          }
        });
      }
    },
    submitForm() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'put';
          }
          let formData = Object.assign(this.model, values);
          console.log("表单提交数据", formData)
          httpAction(httpurl, formData, method).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok');
            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }

      })
    },
    popupCallback(row) {
      this.form.setFieldsValue(pick(row, 'date', 'startTime', 'endTime', 'total', 'surplus', 'doctorId', 'doctorNanme', 'invaild',''))
    },
  }
}
</script>